export async function downloadFileAuthenticated(pathOrUrl: string, filename?: string) {
  const apiUrl = import.meta.env.VITE_SIMPLE_REST_URL;
  const url = pathOrUrl.startsWith('http')
    ? pathOrUrl
    : `${apiUrl}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;

  const windowRef = window.open();
  if (!windowRef) throw new Error('Popup blocked');

  const token = localStorage.getItem('accessToken') || '';

  const headers: Record<string, string> = {
    Authorization: token ? `Bearer ${token}` : '',
  };

  // Add tenant code header (matching customDataProvider logic)
  const tenantsEnabled = import.meta.env.VITE_TENANTS_ENABLED === 'true';
  if (tenantsEnabled) {
    try {
      const currentTenantJson = localStorage.getItem('currentTenant');
      const tenantCode = currentTenantJson ? JSON.parse(currentTenantJson).code : 'default';
      if (tenantCode) headers['x-tenant-code'] = tenantCode;
    } catch (_) {
      headers['x-tenant-code'] = 'default';
    }
  } else {
    // When multi-tenancy is disabled, use default tenant
    headers['x-tenant-code'] = 'default';
  }

  const res = await fetch(url, { headers });
  if (!res.ok) {
    const txt = await res.text();
    windowRef.close();
    throw new Error(txt || `Failed to download (status ${res.status})`);
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  windowRef.location.href = objectUrl;

  // Trigger a download filename if provided
  if (filename) {
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
}


